import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-24">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.04)] p-12" data-testid="payment-success-message">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          <h1 className="text-3xl font-light text-[#374963] mb-4">¡Pago Exitoso!</h1>
          <p className="text-[#73706e] mb-8 leading-relaxed">
            Tu pedido ha sido procesado correctamente. Recibirás un correo electrónico con los detalles de tu compra.
          </p>
          <div className="space-y-3">
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full px-6 py-3 bg-[#374963] text-white rounded-lg hover:bg-[#4A5F7D] transition-colors"
              data-testid="go-to-dashboard-button"
            >
              Ver mis Pedidos
            </button>
            <button
              onClick={() => navigate('/')}
              className="w-full px-6 py-3 bg-white border border-[rgba(55,73,99,0.2)] text-[#374963] rounded-lg hover:bg-[#FAFAFA] transition-colors"
              data-testid="go-to-home-button"
            >
              Volver al Inicio
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;